import React from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import Button from '../common/Button'
import LoadingButton from '../common/LoadingButton'
import podType from '../common/types/podType'
import DestroyPod from './queries/DestroyPod'
import PodsQuery from './queries/PodsQuery'

const Container = styled.div`
  background: white;
  padding: 40px 60px;
  box-shadow: 3px 3px 7px -1px rgba(0,0,0,0.6);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #bebebe;
`
const ConfirmButton = styled(LoadingButton)`
  height: 44px;
  background: #3399cc;
  color: white;
  margin-left: 25px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.36px;
  line-height: 22px;
`
const CancelButton = styled(Button)`
  background: white;
  border: 2px solid #3399cc;
  border-radius: 3px;
  color: #3399cc;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.36px;
  line-height: 22px;
`
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const PodName = styled.div`
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
`
const Question = styled.div`
  font-family: "Zilla Slab";
  font-size: 30px;
  font-weight: 500;
  margin-top: 42px;
  margin-bottom: 80px;
`

export class ConfirmDeletePodModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }
  static propTypes = {
    destroyPod: PropTypes.func.isRequired,
    pod:        podType
  }
  onConfirm = async () => {
    const { destroyPod, pod } = this.props
    const { rid } = pod
    this.setState({ loading: true })
    await destroyPod({
      variables: {
        podId: rid
      },
      update: store => {
        const queryVars = { query: PodsQuery, variables: { role: 'UW' } }
        const data = store.readQuery(queryVars)
        const podIndex = data.pods.findIndex(pod => pod.rid === rid)
        data.pods.splice(podIndex, 1)
        store.writeQuery({ ...queryVars, data })
      }
    })
  }
  render() {
    const { loading } = this.state
    const { onCancel } = this.props
    const { name } = this.props.pod
    return (
      <Container>
        <PodName>{name}</PodName>
        <Question>Are you sure you want to delete this pod?</Question>
        <ButtonsContainer>
          <CancelButton onClick={onCancel}>
            No, do not delete
          </CancelButton>
          <ConfirmButton onClick={this.onConfirm} loading={loading}>
            Yes, delete this pod
          </ConfirmButton>
        </ButtonsContainer>
      </Container>
    )
  }
}

export default graphql(DestroyPod, {
  name: 'destroyPod'
})(ConfirmDeletePodModal)
